import { RailTrackResponseDto, RailVisitResponseDto } from '@planning/app/api'
import { FormStore } from '@tom-ui/utils'
import dayjs from 'dayjs'
import { makeObservable, observable, runInAction } from 'mobx'
import { RailVisitCargoFormStoreType } from './RailVisitCargoFormStore'
import {
  RailVisitGeneralInformationFormStoreType,
  RailVisitVoyageDto,
} from './RailVisitGeneralInformationFormStore'
import { RailVisitTrackAndTimingFormStoreType } from './RailVisitTrackAndTimingFormStore'

export type RailVisitFormStoreType = {
  generalInformation?: RailVisitGeneralInformationFormStoreType
  cargo?: RailVisitCargoFormStoreType
  trackAndTiming?: RailVisitTrackAndTimingFormStoreType
  notes?: string | null
}

const buildInitialValue = (initialData: RailVisitFormStoreInitialData): RailVisitFormStoreType => {
  const railVisit = initialData.railVisit

  const generalInformation: RailVisitGeneralInformationFormStoreType = {
    trainName: railVisit?.identifier,
    trainOperator: railVisit?.trainOperator,
    voyages: initialData.voyages,
  }

  const cargo: RailVisitCargoFormStoreType = {
    cargoType: railVisit?.cargoType ?? null,
    dischargeEstimate: railVisit?.dischargeEstimate ?? 0,
    loadEstimate: railVisit?.loadEstimate ?? 0,
  }

  const eta = railVisit?.eta ? dayjs(railVisit.eta) : null
  const etd = railVisit?.etd ? dayjs(railVisit.etd) : null
  const trackAndTiming: RailVisitTrackAndTimingFormStoreType = {
    etaDate: eta,
    etaTime: eta,
    etdDate: etd,
    etdTime: etd,
    railcarEstimate: railVisit?.railcarEstimate ?? 0,
    visitType: null,
    schedule: null,
    railTracks: initialData.railTracks ?? null,
  }

  return { generalInformation, cargo, trackAndTiming }
}

export type RailVisitFormStoreInitialData = {
  railVisit?: RailVisitResponseDto | null
  voyages?: RailVisitVoyageDto[]
  railTracks?: RailTrackResponseDto[] | null
}

export class RailVisitFormStore extends FormStore<RailVisitFormStoreType> {
  id?: number

  constructor(initialData?: RailVisitFormStoreInitialData) {
    if (initialData) {
      const initialValues = buildInitialValue(initialData)
      super(initialValues)
    } else {
      super({})
    }

    makeObservable(this, {
      id: observable,
    })

    runInAction(() => {
      this.id = initialData?.railVisit?.id
    })
  }

  get data(): RailVisitFormStoreType {
    return {
      ...super.data,
    }
  }
}
